import httpauth from "@/services/httpauth.js";
import axios from 'axios';
import JSZip from 'jszip';
const api = {
  getCategoryMedical() {
    return httpauth.get('/category-medical');
  },

  getPatology() {
    return httpauth.get('/patology');
  },
  getCompany() {
    return httpauth.get('/companies');
  },
  getAnatomicalDistrict() {
    return httpauth.get('/anatomical-district');
  },
  getUsers() {
    return httpauth.get('/users');
  },
  loadComments(activity_id) {
    return httpauth
      .get("/comments/show/" + activity_id, [
        { params: { activity_id: activity_id } },
      ]);
  },
  checkPermission(multiple, section, permission) {
    const form = {
      multiple: multiple,
      section: section,
      permission: permission
    };
    return httpauth
      .post("/check-permission", form);
  },
  getAttachments(model, modelId) {
    var formData = {
      model: model,
      modelId: modelId
    }
    return httpauth.post('/attachments/show', formData);
  },
  async uploadAttachments(uploadFiles, modelId, model, returned, progressCallback) {
    const formData = new FormData();

    formData.append("model_id", modelId);
    formData.append("model", model);
    formData.append("returned", returned);
    const nameZip = modelId + '_' + model + '_' + Date.now() + '.zip';


    return new Promise((resolve, reject) => {
      httpauth.get('/signed-url-google-bucket/' + nameZip).then((response) => {
        var urlSigned = response.data.data.url;


        var zip = new JSZip();
        uploadFiles.forEach((file) => {
          zip.file(file.name, file);
        });

        zip.generateAsync({ type: 'blob' }).then((zipBlob) => {
          axios.put(urlSigned, zipBlob, {
            headers: {
              'Content-Type': 'application/octet-stream', // Assicurati che il tipo di contenuto corrisponda a quello specificato nella generazione dell'URL firmato
            },
            onUploadProgress: progressEvent => {
              // Calcola e chiama la callback con la percentuale di avanzamento dell'upload
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              if (progressCallback)
              {
                progressCallback(percentCompleted);
              }
            }
          }).then((response) => {

            console.log(response);
            formData.append('file', nameZip);
            resolve(httpauth
              .post("/attachments/async-load", formData, {
                onUploadProgress: progressEvent => {
                  // Calcola e chiama la callback con la percentuale di avanzamento dell'upload
                  const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  if (progressCallback)
                  {
                    progressCallback(percentCompleted);
                  }
                }
              }));
          }).catch((error) => {
            reject(error);

          });
        }).catch((error) => {
          reject(error);
        });


      }).catch((error) => {
        reject(error);
      });
    });

  },

  deleteAttachment(attachmentId) {
    return httpauth.get('/attachments/delete/' + attachmentId);
  },
  checkDicom(file) {
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);

    //Fired after sucessful file read, Please read documenation for FileReader
    return reader.onload = function (evt) {
      if (evt.target.readyState === FileReader.DONE)
      {

        var array = new Uint8Array(evt.target.result);
        var s = "";
        var start = 128, end = 132;
        for (var i = start; i < end; ++i)
        {
          s += array[i].toString(16);
        }

        if (s == '4449434d')
        {
          return true;
        }

        else
        {

          return false;
        }
      }
    };
  }
};

export default api;
